import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsForgeAppsNextgenRoute: InvariantJiraRoute = {
	name: 'project-settings-software-apps-forge',
	path: '/jira/software/projects/:projectKey/settings/apps/:appId/:envId/:route?',
};
